module.exports = __webpack_public_path__ + "static/media/grid3.0380b511.png";